import Image from 'next/image';
import { useState } from 'react';
import cls from 'classnames';
import { IFaqBlockProps } from './interface';
import CollapsedCard from './CollapsedCard';

const FaqBlock = ({ FaqBlocks }: IFaqBlockProps) => {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <div>
      {FaqBlocks?.map((ele, index) => {
        return (
          <div key={index} className=" rounded-lg mb-2 last:mb-0 bg-white shadow-[0px_1px_rgb(12_23_32_/_10%)]">
            <div
              className="bg-transparent z-[1px] md:py-6 py-4 relative md:pl-6 md:pr-9 pr-[50px] pl-4 flex justify-between align-center cursor-pointer text-[13px] leading-[20px] sm:text-sm sm:leading-[21px] text-[#111111]"
              onClick={() => (index === openIdx ? setOpenIdx(null) : setOpenIdx(index))}
            >
              <div className="font-semibold md:text-lg text-[#111111] md:text-black md:leading-[21px] text-[14px] leading-[21px]">
                <span dangerouslySetInnerHTML={{ __html: `${index + 1}. ${ele.label}` }}></span>
              </div>

              <div
                className={`absolute ${
                  index === openIdx && '-rotate-180'
                } right-5 transition-all w-[10px] h-[6px] top-[33px] duration-200 `}
              >
                <i className={cls('faq-icons inline-block  icon-arrow-down align-top ')} />
              </div>
            </div>
            <CollapsedCard index={index} openingIdx={openIdx} FaqData={ele.description} />
          </div>
        );
      })}
    </div>
  );
};

export default FaqBlock;
